var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetBallTransformed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a99363d4-c53b-4cfc-9a72-894d479c7ba5",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vbl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64,23.62A40.38,40.38,0,1,0,104.38,64,40.43,40.43,0,0,0,64,23.62Zm0,77.76A37.38,37.38,0,1,1,101.38,64,37.43,37.43,0,0,1,64,101.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,30.05A34,34,0,1,0,98,64,34,34,0,0,0,64,30.05ZM64,95A31,31,0,1,1,95,64,31,31,0,0,1,64,95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.75 77.56 48.28 67.01 46.25 69.22 60.25 82.11 83 49.18 80.53 47.48 59.75 77.56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetBallTransformed);
export default __webpack_public_path__ + "static/media/set-ball-transformed.cabd79c95473538edd9c4f67c7d78226.svg";
export { ForwardRef as ReactComponent };